export default "__VITE_ASSET__641cbf99__"